import EN from './en.png'
import HK from './hk.png'
import ID from './id.png'
import TH from './th.png'
import VI from './vi.png'
import store from '@/store'
import { computed } from 'vue'
const langToImgMap = {
  en: EN,
  sg: EN,
  my: EN,
  ph: EN,
  in: EN,
  hk: HK,
  tw: HK,
  id: ID,
  th: TH,
  vi: VI,
}

export default computed(() => {
  return langToImgMap[store.state.locale]
})
